import { Button, Flex, useToast } from '@chakra-ui/react';
import useToastError from 'hooks/shared/useToastError';
import FullScreenLoader from 'presentation/components/shared/FullScreenLoader';
import AlertModal from 'presentation/components/shared/modals/AlertModal';
import {
  ButtonSize,
  ButtonVariant,
} from 'presentation/theme/components/button';
import { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useRequestManagerCallMutation } from 'rtkQuery/sharespro/queries/services';

interface Props {
  text: string;
  title: string;
  isOpen: boolean;
  onClose: () => void;
  serviceId: ID;
  onSubmit?: (id: ID) => Promise<unknown>;
}

const RequestServiceManagerCallModal: FC<Props> = ({
  text,
  title,
  isOpen,
  onClose,
  serviceId,
  onSubmit,
}) => {
  const { t } = useTranslation();

  const toast = useToast();

  const toastErrorHandler = useToastError();

  const [requestManagerCall, { isLoading: isDefaultLoading }] = useRequestManagerCallMutation();
  const [isCustomLoading, setIsCustomLoading] = useState(false);

  const isLoading = isDefaultLoading || isCustomLoading;

  return (
    <>
      <AlertModal
        isOpen={isOpen}
        onClose={onClose}
        text={text}
        title={title}
        footer={
          <Flex>
            <Button
              variant={ButtonVariant.Ghost}
              mr={3}
              size={ButtonSize.sm}
              onClick={onClose}
            >
              {t('requestCallManagerDecline')}
            </Button>
            <Button
              size={ButtonSize.sm}
              onClick={() => {
                if (onSubmit) {
                  setIsCustomLoading(true);
                  onSubmit(serviceId)
                    .then(() => {
                      toast({
                        description: t('requestCallManagerSuccess'),
                        status: 'success',
                        position: 'top-right',
                        duration: 10000,
                        isClosable: true,
                      });
                      onClose();
                    })
                    .catch((err) => toastErrorHandler(err))
                    .finally(() => setIsCustomLoading(false));
                } else {
                  requestManagerCall(serviceId)
                    .unwrap()
                    .then(() => {
                      toast({
                        description: t('requestCallManagerSuccess'),
                        status: 'success',
                        position: 'top-right',
                        duration: 10000,
                        isClosable: true,
                      });
                      onClose();
                    })
                    .catch((err) => toastErrorHandler(err));
                }
              }}
            >
              {t('requestCallManagerAccept')}
            </Button>
          </Flex>
        }
      />
      <FullScreenLoader isLoading={isLoading} />
    </>
  );
};

export default RequestServiceManagerCallModal;
